"use strict";

const ToastPort = {
  add: function (app, emrHost) {
    if (app.ports.sendToastMessagePort) {
      app.ports.sendToastMessagePort.subscribe(function (levelAndMessage) {
        let targetOrigin = emrHost;
        try {
          if (window.parent.location.origin === window.location.origin) {
            targetOrigin = window.parent.location.origin;
          }
        } catch {
          /* cross-origin iframe, keep emrHost */
        }
        window.parent.postMessage(
          { message: levelAndMessage[1], type: `alert.${levelAndMessage[0]}` },
          targetOrigin,
        );
      });
    }
  },
};

module.exports = ToastPort;
